import { HttpClient } from '@adapters/HttpClient';
import {
  ShippingRulePresetApplication,
  ShippingRulePresetApplicationsFilters,
  ShippingRulePresetApplicationsPage,
} from '../models/ShippingRulePresetApplication';

export class ShippingRulePresetApplicationsApiAdapter {
  constructor(private httpClient: HttpClient) {}

  async getApplicationsPaginated(
    filters: ShippingRulePresetApplicationsFilters = {},
  ): Promise<ShippingRulePresetApplicationsPage> {
    const { page = 1, per_page = 15, sortBy = 'applied_at', sortDirection = 'desc' } = filters;

    const params: Record<string, any> = {
      page,
      per_page,
      ...(sortBy && { 'sorting[column]': sortBy }),
      ...(sortDirection && { 'sorting[direction]': sortDirection }),
    };

    const response = await this.httpClient.get<any>('/shipping-rule-preset-applications', params, {}, page === 1);

    return {
      applications: response.data,
      nextPage: response.meta.current_page < response.meta.last_page ? response.meta.current_page + 1 : undefined,
      hasMore: response.meta.current_page < response.meta.last_page,
      total: response.meta.total,
    };
  }

  async getApplicationById(id: number): Promise<ShippingRulePresetApplication> {
    return this.httpClient.get<ShippingRulePresetApplication>(`/shipping-rule-preset-applications/${id}`);
  }
}
